module.exports = __webpack_public_path__ + "media/images/signature-dc5bf2b328d242a53f1c9b6a18432ad3.png";